module.exports = __webpack_public_path__ + "static/media/8OLA11.ff536188.jpg";